import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
export default function Favicon(_ref) {
  var domain = _ref.domain,
      props = _objectWithoutProperties(_ref, ["domain"]);

  return React.createElement("img", Object.assign({
    style: {
      height: 16
    },
    src: "https://www.google.com/s2/favicons?domain=".concat(domain),
    alt: "domain-".concat(domain, "-favicon")
  }, props));
}
Favicon.propTypes = {
  domain: PropTypes.string.isRequired
};